// removed by extract-text-webpack-plugin
module.exports = {"content":"_3DZOHCySnu9bY3i7f2uf6y","slide":"_1Btt_D0eeiLs1NDtVKKaE7","empty":"_2pBTZ_E8dsiEbjJHRhmu2B","dropzone":"upZsJwccu1NXkDq9yfAPw","progress":"_3RecV4xB1xdvIY2qPTStlc","details":"zFXoQhsObOjfckPzjTQr","input":"_3Rp4zTgrT03Y1H9PDigCyr","label":"_1bdonwO2SVZS79yWAUP2_3","inputTitle":"pEHWTj6qhh1xzEoG0pCfj","inputDescription":"_2GuJ_496SWOkk2hyhVVgiS","productMeta":"_3pnt-aSGFAAfVr71B5miq2","buttonSave":"_31OZApbmmV0xgDdVBtGMjC"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Item/EditModal/EditModal.scss
 ** module id = 734
 ** module chunks = 0
 **/